import { getCreateDomain, getWorldsDomain } from '@/lib/configs'
import type { EditorChoiceCards, Owner } from '@/services/cms'

export const isViverseProOwner = (owner: Pick<Owner, 'viverse_pro'> | null | undefined) => {
  return owner?.viverse_pro === true
}

type CreatorBadgeSource = {
  viverse_pro?: boolean
  verified_creator?: boolean
}

export const hasVerifiedCreatorBadge = (account: CreatorBadgeSource | null | undefined) => {
  return account?.viverse_pro === true || account?.verified_creator === true
}

export const extractRoomIdFromUrl = (url: string) => {
  if (!url) return '/'

  const worldsDomain = `https://${getWorldsDomain()}`
  const createDomain = `https://${getCreateDomain()}`

  if (!url.startsWith(worldsDomain) && !url.startsWith(createDomain)) {
    return url
  }

  const { pathname, search } = new URL(url, 'https://x')
  return `${pathname}${search}`
}

export const resolveWorldsRoomUrl = (url: string | undefined | null): URL | null => {
  if (!url) return null

  const worldsDomain = `https://${getWorldsDomain()}`
  if (!url.startsWith(worldsDomain)) return null

  const parsed = new URL(url, 'https://x')
  // Reject protocol-relative paths (e.g. `//evil.com`) that could shift routing.
  if (!parsed.pathname.startsWith('/') || parsed.pathname.startsWith('//')) return null

  return parsed
}

export const filterNonePremiumWorlds = async (allWorldsPromise: Promise<EditorChoiceCards[]>) => {
  const allWorlds = await allWorldsPromise

  const newWorlds = allWorlds
    .filter((worlds) => worlds.rooms && !worlds.is_premium)
    .flatMap((worlds) => worlds.rooms)

  return {
    rooms: newWorlds,
  } as EditorChoiceCards
}

export const filterPremiumWorlds = async (allWorldsPromise: Promise<EditorChoiceCards[]>) => {
  const allWorlds = await allWorldsPromise

  const premiumWorlds = allWorlds
    .filter((worlds) => worlds.rooms && worlds.is_premium)
    .flatMap((worlds) => worlds.rooms)

  return {
    rooms: premiumWorlds,
  } as EditorChoiceCards
}
